import React from "react";
import './footer.css';
import logotec from '../../images/LOGO_TECNM_BLANCO.png'

function Footer() {
  return (
    <div>
      {/* <div className="Footer">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-lg-5 col-12 ft-1">
                            <h3><span>ITCV</span> <img src={logoitcv} alt='logoitcv' style={{ width: '15%', height: '15%' }}/> </h3>
                            <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Laborum ea quo ex ullam laboriosam magni totam, facere eos iure voluptate.</p>

                        </div>
                        <div className="col-md-6 col-lg-3 col-12 ft-2">
                            <h5>Quick Links</h5>
                            <ul>
                                <li className="nav-item">
                                    <a className="" href="/">Services</a>
                                </li>
                                <li className="nav-item">
                                    <a className="" href="/">Contact Us</a>
                                </li>
                                <li className="nav-item">
                                    <a className="" href="/">Services</a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-6 col-lg-4 col-12 ft-3">
                            <h5>Quick Links</h5>
                            <p><i class="fas fa-phone"></i></p>
                            <p><i class="fas fa-envelope"></i></p>
                            <p> <i class="fas fa-paper-plane"></i> </p>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className='Last-footer'>
                <p><img src={logotec} alt='logo' style={{ width: '8%', height: '8%' }}/> </p>
            </div>
    </div>
  );
}

export default Footer;